import {isMobile, isTablet} from "../components/helpers";
import {initHeaders} from "../components/archive-effect";

export function initArchiveLanding() {
    if (!$('#archive_landing').length) return;

    //добавление линков для пред загрузки image на архиве
    $(document).find('div.image').each((_, image) => {
        const href = $(image).data('background-image');
        let link = document.createElement('link');
        link.href = href;
        link.rel = 'preload';
        link.as = 'image';
        document.head.appendChild(link);
        $(image).css('opacity', '1');
    })

    const modal = $('.archive-modal-wrapper');
    const closeModal = $('.close-modal-archive');
    const modalTitle = modal.find('.title');
    const modalDescription = modal.find('.description');
    const modalLink = modal.find('.project-link');
    const modalImage = modal.find('.image');

    $('.work').on('click', e => {
        const block = $(e.currentTarget);

        if (block.data('href')) {
            window.location.href = block.data('href');

        } else {
            cleanModal();
            const linkHTML = `${block.data('link')}<span class="unused">${block.data('link-dot')}</span>`

            modalTitle.text(block.find('.text').text());
            modalDescription.text(`${block.data('description')}`);
            modalLink.html(linkHTML);
            modalImage.css('background-image', `url(${block.find('.image').data('background-image')})`);

            modal.addClass('show');

            if (isMobile() || isTablet()) {
                setTimeout(() => {
                    modal.addClass('show-effect');
                }, 5);
            }

            if (!isMobile() && !isTablet()) {
                $('body').addClass('open-modal');
            } else {
                $('body').css('overflow', 'hidden');
            }

            if (block.find('.text').text() === 'Самаранефтепромлизинг' && !isTablet() && !isMobile()) {
                modalTitle.css('word-break', 'break-all');
            } else {
                modalTitle.css('word-break', 'inherit');
            }
        }

    });

    $(closeModal).on('click', () => {
        if (!isMobile() && !isTablet()) {
            $('body').removeClass('open-modal');
            modal.removeClass('show');

        } else {
            $('body').css('overflow', 'auto');
            modal.removeClass('show-effect');
            setTimeout(() => {
                modal.removeClass('show');
            }, 250);
        }
    });


    function cleanModal() {
        modalTitle.empty();
        modalDescription.empty();
        modalLink.empty();
        modal.find('.unused').empty();
        modalImage.css('background-image', '');
    }

    initHeaders();
}
